let mySwiper = new Swiper ('.swiper', {
  // オプション設定
  loop: true,
    // 自動再生設定
  autoplay: {
    delay: 3000, // 2.5秒ごとにスライド
    disableOnInteraction: false, // ユーザーのスワイプ操作後に自動再生を停止しない
  },

  //ページネーション表示設定
  pagination: {
    el: '.swiper-pagination', //ページネーション要素
    type: 'bullets', //ページネーションの種類
    clickable: true, //クリックに反応させる
  },

   //ナビゲーションボタン（矢印）表示設定
   navigation: {
    nextEl: '.swiper-button-next', //「次へボタン」要素指定
    prevEl: '.swiper-button-prev', //「前へボタン」要素指定
  },

});
